<div class="dialog">
    <div class="dialog_header">
        <button mat-icon-button class="close" [disabled]="loading" (click)="openConfirmDialog()"><svg
                xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path id="ic_close"
                    d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                    transform="translate(-204.746 755.5)" fill="#999" />
            </svg>
        </button>
        {{ (data.type =='check-in' ? "hrService.editAttendanceTime" :"hrService.editDepartureTime") | translate}}
    </div>
    <form [formGroup]="formGroup" class="library-form">
        <div class="p-0">
            <div class="dialog_content pb-0" mat-dialog-content>
                <div class=" font-14 light-grey-color fontRegular mb-4">
                    {{(data.type =='check-in' ? "hrService.currentAttendanceTime" :
                    "hrService.currentDepartureTime")|translate}}
                    <span class="font-18 fontRegular text-color"> {{(data.type =='check-in'?
                        data.history[data.index].time_in :
                        data.history[data.index].time_out) | date: 'h:mm a'}}

                        <span class="red-color font-16">
                            {{data.type =='check-out' && !data.history[data.index].time_out ?
                            ('hrService.Not Registered' | translate):''}}</span>
                    </span>
                </div>
                <div class="fields-group mb-3">

                    <div class="form-to-time hr-services d-flex">
                        <mat-form-field>
                            <mat-label>
                                {{(data.type =='check-in'? "hrService.attendanceTime" :
                                "hrService.departureTime")|translate}}
                            </mat-label>
                            <input matInput [ngxTimepicker]="Time" [max]="MaxTime" [min]="MinTime" readonly
                                formControlName="time" [format]="12">
                            <div matSuffix class="d-flex align-items-center">
                                <mat-icon matSuffix *ngIf="formGroup.value.time" style="line-height: 1.125"
                                    (click)="resetTimeValue()">clear
                                </mat-icon>
                                <ngx-material-timepicker-toggle [for]="Time"></ngx-material-timepicker-toggle>
                            </div>
                            <ngx-material-timepicker #Time></ngx-material-timepicker>
                            <mat-error *ngIf="hasError('time', 'required')">{{
                                'forms.Required' | translate
                                }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="fields-group mb-3">
                    <mat-form-field>
                        <mat-label>{{"hrService.editReason"|translate}}</mat-label>
                        <textarea matInput maxlength="150" formControlName="reason"></textarea>
                        <mat-error *ngIf="hasError('reason','required')">
                            {{"form_message.Required"|translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>
        </div>



        <div class="dialog_actions" mat-dialog-actions>
            <button mat-button type="button" [disabled]="loading" class="btn-secondary"
                (click)="openConfirmDialog()">{{"general.Cancel"|translate}}</button>

            <button mat-button [disabled]="loading || formGroup.invalid" [class.loading]="loading"
                (click)="saveRecord()" class="btn-primary">
                {{"userProfile.confirm" | translate}}
            </button>
        </div>
    </form>
</div>